import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ConversationItem = _resolveComponent("ConversationItem")
  const _component_LoadingPlaceholder = _resolveComponent("LoadingPlaceholder")
  const _component_RecycleScroller = _resolveComponent("RecycleScroller")

  return (_openBlock(), _createBlock(_component_RecycleScroller, {
    ref: "scroller",
    "item-tag": "ul",
    items: $props.conversations,
    "item-size": $setup.itemSize,
    "key-field": "token"
  }, {
    default: _withCtx(({ item }) => [
      _createVNode(_component_ConversationItem, {
        item: item,
        compact: $props.compact
      }, null, 8, ["item", "compact"])
    ]),
    after: _withCtx(() => [
      ($props.loading)
        ? (_openBlock(), _createBlock(_component_LoadingPlaceholder, {
            key: 0,
            type: "conversations"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["items", "item-size"]))
}